import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';
import { MyStelliumService } from '@lib/services/mystellium.service';
import { PreviewDocumentEmailTemplateInput } from '@lib/models/generated/myStellium-graphql';
import { EmailTemplatePreviewComponent } from '../../email-template-preview/email-template-preview.component';

@Component({
  selector: 'email-preview-dialog',
  imports: [SHARED_IMPORTS, EmailTemplatePreviewComponent],
  templateUrl: './email-preview-dialog.component.html',
  styleUrl: './email-preview-dialog.component.scss',
})
export class EmailPreviewDialogComponent {
  private readonly myStelliumService = inject(MyStelliumService);
  readonly data = inject<PreviewDocumentEmailTemplateInput>(MAT_DIALOG_DATA);
  readonly emailPreviewLoading = signal(false);
  readonly emailPreviewHtml = signal<string | null>(null);

  constructor() {
    this.loadEmailPreview();
  }

  private async loadEmailPreview(): Promise<void> {
    this.emailPreviewLoading.set(true);
    try {
      const html = await this.myStelliumService.previewDocumentEmailTemplate(this.data);
      this.emailPreviewHtml.set(html);
    } catch (error) {
      console.error(error);
    } finally {
      this.emailPreviewLoading.set(false);
    }
  }
}
